import EventManager from "~/ts/library/EventManager"

export const ChatEventManagerInstance = new EventManager();

export const CLIENT_FIELD_CHANGED_EVENT = "clientFieldChanged";
export const OPEN_LIGHTBOX_EVENT = "openLightbox";
export const SCROLL_TO_MESSAGE_BY_ID = "scrollToMessageById";

export function openChatLightbox(src: string) {
    ChatEventManagerInstance.emit(OPEN_LIGHTBOX_EVENT, src);
}